import React, { Component } from 'react'
import parse from 'html-react-parser'
import Link from '../utils/link'
import { GatsbyImage } from 'gatsby-plugin-image'
import ReCAPTCHA from "react-google-recaptcha";

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

class Form extends Component {
  state = {
    result: null,
    msg: null,
  }

  constructor(props) {
    super(props)
    this.reCaptchaElement = React.createRef()
    this.form = React.createRef()
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = e => {
    e.preventDefault()

    // Make sure the form itself is valid (HTML5 validation)
    if (this.form.current && !this.form.current.checkValidity()) {
      // Optionally trigger native validation UI
      this.form.current.reportValidity?.()
      return false
    }

    // Safely check reCAPTCHA value if the widget is present
    if (!this.reCaptchaElement.current || !this.reCaptchaElement.current.getValue()) {
      this.setState({
        result: 'fail',
        msg: 'Please complete the reCAPTCHA before submitting.'
      })
      return false
    }

    fetch(`https://hooks.zapier.com/hooks/catch/3298056/ugm9vh5/`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        ...this.state
      })
    })
      .then(() => {
        this.setState({ result: "success", msg: null })
        // Optionally reset the captcha
        if (this.reCaptchaElement.current) {
          this.reCaptchaElement.current.reset()
        }
      })
      .catch(error => this.setState({ result: "fail", msg: error?.message || String(error) }))
  }

  render () {
    const props = {
      ref: this.form,
      name: 'contact',
      className: 'form',
      onSubmit: this.handleSubmit,
    }

    if (this.state.result === 'success') {
      return (
        <p>Thank you for signing up to Fight Free February! Look out for tips in your inbox soon.</p>
      )
    }

    return (
      <form {...props} className="subscribe__form">
        <div className="subscribe__row">
          <div className="subscribe__field">
            <input
              type="text"
              name="firstName"
              onChange={this.handleChange}
              className="subscribe__input"
              placeholder="First name"
              required
            />
          </div>

          <div className="subscribe__field">
            <input
              type="text"
              name="lastName"
              onChange={this.handleChange}
              className="subscribe__input"
              placeholder="Last name"
              required
            />
          </div>
        </div>

        <div className="subscribe__field subscribe__field--full">
          <input
            type="email"
            name="email"
            onChange={this.handleChange}
            className="subscribe__input"
            placeholder="Email Address"
            required
          />
        </div>

        <div className="subscribe__field subscribe__field--full">
          <ReCAPTCHA
            ref={this.reCaptchaElement}
            sitekey="6LdtvMwpAAAAAO7UujWkbHLEL0S_utziTQSagAPC"
          />
        </div>

        {this.state.result === 'fail' && this.state.msg && (
          <p className="subscribe__error">{this.state.msg}</p>
        )}

        {/* Using type="button" so only this handler fires */}
        <button
          type="button"
          onClick={this.handleSubmit}
          className="subscribe__button"
        >
          Subscribe
        </button>
      </form>
    )
  }
}

const SubscribeForm = ({ title }) => {
  return (
    <section className='subscribe-section'>
      <div className="subscribe">
        <div className="subscribe__inner">
          <h1 className="subscribe__title">{title}</h1>
          <Form />
        </div>
      </div>
    </section>
  )
}

export default SubscribeForm
